var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.menuList.length>0)?_c('div',{staticClass:"secondmenu-wrap"},[_c('ul',{staticClass:"second-menu response"},_vm._l((_vm.menuList),function(item,index){return _c('li',{key:index,staticClass:"second-menu-item pointer",class:{
        active:
          !!_vm.$route.query.cate_id || _vm.$route.query.id == 0
            ? _vm.$route.query.cate_id - 0 == item.id
            : item.id == _vm.menuList[0].id - 0,
      },on:{"click":function($event){return _vm.changeMenu(item, index)}}},[_c('span',[_vm._v(" "+_vm._s(item.title)+" ")])])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }